import moment from 'moment';

const months = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

const getMonthYearly = (year: any) => {
  return months.map((month) => ({
    month_year: `${month}-${new Date(year).getFullYear()}`,
  }));
};

const getMonthNumber = (month: string) => {
  const months = [
    'jan',
    'feb',
    'mar',
    'apr',
    'may',
    'jun',
    'jul',
    'aug',
    'sep',
    'oct',
    'nov',
    'dec',
  ];
  return months.findIndex((m) => m.toLowerCase() === month.toLowerCase());
};

const getDaysArr = (monthYear: string) => {
  if (!monthYear) return [];

  const [monthName, year] = monthYear.split('-');
  const month = Number(getMonthNumber(monthName));
  if (month === -1) return [];

  const daysArr = [];
  let date = moment(`${year}-${month + 1}`, 'YYYY-MM');

  while (date.month() === month) {
    daysArr.push({ [date.date()]: date.format('dddd').toLowerCase() });
    date = date.add(1, 'days');
  }

  return daysArr;
};

export { getMonthYearly, getDaysArr };
